export const isCompanyEnabled = async (company) => {
  if (company) {
    return !company.isDisabled;
  } else {
    return false;
  }
};
